export default "__VITE_ASSET__c92f1ea1__"